import { combineReducers } from "redux";
import * as actionTypes from "../actionTypes/authTypes";

import auth from "./authReducer";
import events from "./eventsReducer";
import barCodes from "./barCodesReducer";
import promoters from "./promotersReducer";
import scanteams from "./scanteamsReducer";
import payments from "./paymentReducer";
import ticketGeneration from "./ticketGenerationReducer";
import eventData from "./EventDataReducer";
import { ticketsImport } from "./ticketsImportReducer";
import transactions from "./transactionsReducer";

const appReducer = combineReducers({
  auth,
  events,
  ticketGeneration,
  barCodes,
  promoters,
  scanteams,
  payments,
  eventData,
  ticketsImport,
  transactions,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOGOUT_SUCCESS) {
    state = null;
  }

  return appReducer(state, action);
};

export default rootReducer;
